import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { Link } from "react-router-dom";
import TaskSkeleton from "./TaskSkeleton";

export default function Weekmonthview() {
  const { http, user } = AuthUser();
  const [tasks, setTasks] = useState([]);
  const [date, setDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [remark, setRemark] = useState(null);
  const [departments, setdepartments] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [loginUser, setloginUser] = useState(user.department_id);
  useEffect(() => {
    fetchTaskDetails();
  }, []);

  const fetchTaskDetails = () => {
    setIsLoading(true);
    let endpoint = `/get_week_month?login_user=${user.id}`;

    http
      .get(endpoint)
      .then((res) => {
        setIsLoading(false);
        if (Array.isArray(res.data.data)) {
          setTasks(res.data.data);
        } else {
          setIsLoading(false);
          console.error("API response is not an array");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching tasks:", error);
      });

    http.get("/departments").then((res) => {
      setdepartments(res.data.data);
    });
  };
  const [showModal, setShowModal] = useState(false);
  const [showModalRevise, setShowModalRevise] = useState(false);
  const [ModalId, setModalId] = useState(false);
  const openModal = (taskId) => {
    setShowModal(true);
    setModalId(taskId);
  };

  const openModalRevise = (rmark, revisedate) => {
    setDate(revisedate);
    setRemark(rmark);
    setShowModalRevise(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setShowModalRevise(false);
  };

  const handleChange = async (event) => {
    const selectedDepartmentId = event.target.value;
    try {
      if (selectedDepartmentId === "") {
        fetchTaskDetails();
      } else {
        const response = await http.get(
          `/get_department_task_week_month?department=${selectedDepartmentId}&login_user=${user.id}`
        );
        setTasks(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  const statusUpdate = (e) => {
    setCurrentStatus(e.target.value);
  };

  const handleSave = async (taskId) => {
    if (currentStatus === null || taskId === null) {
      toast.error("Please select proper status");
      return true;
    }
    try {
      const response = await http.put(
        `task_status_update?task_id=${taskId}&status=${encodeURIComponent(
          currentStatus
        )}`
      );
      toast.success("Task status updated successfully !");
      fetchTaskDetails();
    } catch (error) {
      console.error("Error fetching tasks:", error);
      toast.error("Please select proper item");
    }
  };

  const [formData, setFormData] = useState({
    revised_date: "",
    revised_remark: "",
  });
  const initialState = {
    revised_date: "",
    revised_remark: "",
  };

  const handleChangeModal = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      http.put(`/revise/${ModalId}`, formData).then((res) => {
        toast.success("revise date added successfully !");
        setFormData(initialState);
        fetchTaskDetails();
        closeModal();
      });
    } catch (error) {
      console.error("Error adding task:", error.response.data);
    }
  };

  const deleteTask = async (taskId) => {
    await http
      .delete(`/tasks_week_month/${taskId}`)
      .then((response) => {
        toast.success("Task Deleted successfully !");
        fetchTaskDetails();
      })
      .catch((err) => {
        console.error("Error deleting task", err);
      });
  };

  const downloadFile = (filename) => {
    // Construct the URL to the file.
    const fileUrl = `http://3.6.125.26/api/storage/tasks/${filename}&login_user=${user.id}`;

    // Create a link element
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", ""); // the download attribute can be empty
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Remove the link from the DOM
  };

  function getRandomLightColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  const backgroundColorMap = new Map();
  // Function to get a unique background color for a user.id
  function getUniqueBackgroundColor(userId) {
    if (!backgroundColorMap.has(userId)) {
      // If the user.id doesn't have a background color assigned, generate one and store it in the map
      backgroundColorMap.set(userId, getRandomLightColor());
    }
    return backgroundColorMap.get(userId);
  }
  return (
    <>
      <Toaster />

      {showModal && (
        <form onSubmit={handleSubmit}>
          <div className="modal" tabindex="-1" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Revision Details</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModal}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="form-group  mt-3">
                    <label>New Revision Date</label>
                    <input
                      name="revised_date"
                      className="form-control"
                      type="date"
                      onChange={handleChangeModal}
                    />
                  </div>

                  <div className="form-group mt-3">
                    <label>Revision Note</label>
                    <textarea
                      name="revised_remark"
                      className="form-control"
                      onChange={handleChangeModal}
                      rows="3"
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}

      {showModalRevise && (
        <div className="modal" tabindex="-1" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Revision Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="form-group  mt-3">
                  <label>New Revision Date</label>
                  <input
                    name="revised_date"
                    className="form-control"
                    type="date"
                    value={date}
                  />
                </div>

                <div className="form-group mt-3">
                  <label>Revision Note</label>
                  <textarea
                    name="revised_remark"
                    className="form-control"
                    rows="3"
                    value={remark}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="container mt-1 bg-light-week rounded">
        <div className="row">
          <div className="col">
            {user && user.department_id == 1 && (
              <div className="form-group text-end">
                <select onChange={handleChange} className="">
                  <option value="">All</option>
                  <option value="2">Weekly</option>
                  <option value="1">Monthly</option>
                  <option value="3">Once</option>
                  <option value="4">Daily</option>
                </select>
              </div>
            )}
          </div>
          <div className="col">
            <div className="text-end">
              <Link className="btn-link ml-13" to="/week_month_add">
                Add
              </Link>
              <Link className="btn-link ml-13" to="/bulk_task_week">
                Add Bulk Week/Month
              </Link>
            </div>
          </div>
        </div>

        <h1 className="text-danger">Weekly/Monthly List</h1>
        <div className="table-responsive">
          {isLoading ? (
            <TaskSkeleton />
          ) : (
            <table className="table table-striped">
              <thead className="table-primary">
                <tr>
                  <th className="text-danger">Created On</th>
                  <th>Type</th>
                  <th>Scheduled</th>
                  <th>Assigned To</th>
                  <th>Description</th>
                  <th>Department</th>
                  <th>Additional info</th>
                  <th>EST</th>
                  <th>Due Additional Days</th>
                  <th>Weightage</th>
                  <th>Priority</th>
                  <th>Assigned By</th>

                  <th>Action</th>

                  {/* Add other fields as necessary */}
                </tr>
              </thead>
              <tbody>
                {tasks.map((user) => (
                  <tr key={user.id}>
                    <td>{moment(user.created_at).format("DD MMM,YY")}</td>
                    <td>
                      {user.type === 1
                        ? "Monthly"
                        : user.type === 2
                        ? "Weekly"
                        : user.type === 4
                        ? "Daily"
                        : "Once"}
                    </td>
                    <td>
                      {" "}
                      <span className="text-danger">
                        {user.type === 1
                          ? user.type_number_month
                          : user.type === 2
                          ? user.type_number
                          : user.target_date_year}{" "}
                      </span>{" "}
                    </td>
                    <td
                      className={`text-uppercase fw-bold ${
                        user.assignee?.name && user.assignee?.last_name
                          ? "background-color-class"
                          : ""
                      }`}
                      style={{
                        color: getUniqueBackgroundColor(user.assignee?.id),
                      }}
                    >
                      {user.assignee?.name} {user.assignee?.last_name}
                      {user.task_file && (
                        <button
                          className="btn btn-link"
                          onClick={() => downloadFile(user.task_file)}
                        >
                          File
                        </button>
                      )}
                    </td>

                    <td>{user.description}</td>
                    <td>{user.department?.name}</td>
                    <td>{user.additional_info}</td>
                    <td>{user.est_time}</td>
                    <td>{user.target_date}</td>

                    <td>{user.task_weightage}</td>
                    <td>{user.priority}</td>
                    <td className="text-uppercase fw-bold">
                      {user.assigner?.name} {user.assigner?.last_name}
                    </td>

                    <td>
                      <button
                        className="button btn-sm btn-danger"
                        onClick={() => deleteTask(user.id)}
                      >
                        Delete
                      </button>
                      {/* {(loginUser !== 1 ? (
                                                <div>
                                                    <select onChange={statusUpdate} className='form-select-sm mb-2'>
                                                        <option value="">Update Status</option>
                                                        <option value="Progress">Progress</option>
                                                        <option value="Completed">Completed</option>
                                                    </select>
                                                    <button className='btn-sm btn btn-link' onClick={() => handleSave(user.id)}>Save</button>
                                                    <button className='btn-sm btn btn-link' onClick={() => openModal(user.id)}>Revise</button>
                                                </div>
                                            ) : (
                                               
                                            )
                                            )} */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
